import React, { useEffect, useRef, useState } from 'react';
import { Col, Form, FormGroup, Input, Label, Row, Alert } from 'reactstrap';
import { useMediaQuery } from 'react-responsive';

import Loader from '../../Common/Loader';
import RoundedButton from '../../Buttons/RoundedButton/RoundedButton';

import { loadUser, editUser, editUserImage } from '../../../helpers/api/users.api';

import '../Forms.scss';

const ScoutsContentsForm = (props) => {

    const MOBILE_AND_TABLET = useMediaQuery({
        query: "(max-device-width: 768px)",
    });

    let imagePicker = useRef(null);

    const [user, setUser] = useState(null);

    const [loading, setLoading] = useState(false);
    const [loadingImage, setLoadingImage] = useState(false);

    const [error, setError] = useState(false);

    useEffect(() => {
        if (localStorage.getItem('authUser')) {
            setLoading(true);
            const userId = JSON.parse(localStorage.getItem('authUser'))._id;
            loadUser(userId)
                .then((result) => {
                    if (result.success) setUser(result.user);
                    else console.log(result.message);
                    setLoading(false);
                })
                .catch((error) => {
                    setLoading(false);
                    console.log(error);
                });
        }
    }, []);

    function handleOnImageClick() {
        if (imagePicker.current && imagePicker.current.click) imagePicker.current.click();
    }

    function handleOnImageSubmit({ target: { files } }) {
        if (files && files.length > 0) {
            let image = files[0];
            if (!image.type.startsWith('image')) window.alert('Devi caricare un file immagine.');
            else {
                setLoadingImage(true);
                editUserImage(image)
                    .then((result) => {
                        if (result.success) setUser(result.updated);
                        else setError(result.message);
                        setLoadingImage(false);
                    })
                    .catch((error) => {
                        setError(error.message);
                        setLoadingImage(false);
                    });
            }
        }
    }

    function handleOnFieldChange({ target: { name, value } }) {
        let editedUser = { ...user };

        if (['facebook', 'twitter', 'website', 'instagram'].includes(name))
            editedUser.socialLinks[name] = value;
        else editedUser[name] = value;
        setUser(editedUser);
    }

    function handleOnDataUpdateSubmit(event) {
        event.preventDefault();
        setLoading(true);
        editUser(user)
            .then((result) => {
                if (result.success) setUser(result.updated);
                else setError(result.message);
                setLoading(false);
            })
            .catch((error) => {
                setError(error.message);
                setLoading(false);
            });
    }

    return loading ? (
        <Loader />
    ) : error ? (<Alert color="danger">{error}</Alert>) : user ? <Form onSubmit={handleOnDataUpdateSubmit}>
        <FormGroup row>
            <Col md="4">
                <h6>Foto Profilo</h6>
                {loadingImage ? (
                    <Loader />
                ) : user.image ? (
                    <div
                        style={{
                            backgroundImage:
                                'url(' +
                                user.image.url +
                                ')'
                        }}
                        className="avatar-xs rounded-circle profile-avatar"></div>
                ) : null}

                <RoundedButton
                    className="px-5 mt-4"
                    color="primary"
                    onClick={handleOnImageClick}>
                    Carica
                </RoundedButton>
                <Input
                    innerRef={imagePicker}
                    type="file"
                    style={{ display: 'none' }}
                    onChange={handleOnImageSubmit}
                />

                <h6>Informazioni</h6>



                <Label for="job">
                    Occupazione
                </Label>
                <Input
                    type="text"
                    name="job"
                    id="job"
                    value={user.job}
                    onChange={
                        handleOnFieldChange
                    }
                />

                <Label for="city">Città</Label>
                <Input
                    type="text"
                    name="city"
                    id="city"
                    value={user.city}
                    onChange={handleOnFieldChange}
                />

                {!MOBILE_AND_TABLET && <RoundedButton
                    className="px-5 mt-4"
                    color="primary"
                    type="submit">
                    Salva
                </RoundedButton>}
            </Col>
            <Col
                md={{
                    size: 6,
                    offset: 2
                }}>
                <Row>
                    <Col md="8">
                        <h6>Link Social</h6>
                        <Label for="website">
                            Sito Web
                        </Label>
                        <Input
                            type="text"
                            name="website"
                            id="website"
                            value={
                                user.socialLinks
                                    .website
                            }
                            onChange={
                                handleOnFieldChange
                            }
                        />
                        <Label for="facebook">
                            Facebook
                        </Label>
                        <Input
                            type="text"
                            name="facebook"
                            id="facebook"
                            value={
                                user.socialLinks
                                    .facebook
                            }
                            onChange={
                                handleOnFieldChange
                            }
                        />
                        <Label for="instagram">
                            Instagram
                        </Label>
                        <Input
                            type="text"
                            name="instagram"
                            id="instagram"
                            value={
                                user.socialLinks
                                    .instagram
                            }
                            onChange={
                                handleOnFieldChange
                            }
                        />
                        <Label for="twitter">
                            Twitter
                        </Label>
                        <Input
                            type="text"
                            name="twitter"
                            id="twitter"
                            value={
                                user.socialLinks
                                    .twitter
                            }
                            onChange={
                                handleOnFieldChange
                            }
                        />

                        {MOBILE_AND_TABLET && <RoundedButton
                            className="px-5 mt-4"
                            color="primary"
                            type="submit">
                            Salva
                        </RoundedButton>}
                    </Col>
                </Row>
            </Col>
        </FormGroup>
    </Form> : null;
};

export default ScoutsContentsForm;
